import { LANGUAGE_OPTIONS } from 'constants/languages'
import { isSupportedLocale } from 'i18n/util/localeMatcher'

interface SupportedLanguagesRemoteConfigLanguage {
  locale: string
  nativeName?: string
}

interface SupportedLanguagesRemoteConfig {
  languages?: Array<SupportedLanguagesRemoteConfigLanguage>
}

function isSupportedLanguagesRemoteConfig(
  value: unknown,
): value is SupportedLanguagesRemoteConfig {
  return !!value && typeof value === 'object' && !Array.isArray(value) && 'languages' in value
}

export function getSupportedLanguageOptions(
  remoteConfig: App.LabRemoteConfigResult | undefined,
) {
  const fallbackLanguageOptions = LANGUAGE_OPTIONS

  if (remoteConfig?.error) {
    return fallbackLanguageOptions
  }

  const { value } = remoteConfig ?? {}
  if (!isSupportedLanguagesRemoteConfig(value)) {
    return fallbackLanguageOptions
  }

  if (!Array.isArray(value.languages)) {
    return fallbackLanguageOptions
  }

  const languageOptions = value.languages.reduce<Array<typeof fallbackLanguageOptions[number]>>((result, languageConfig) => {
    const { locale, nativeName } = languageConfig
    if (!isSupportedLocale(locale)) {
      return result
    }

    const languageOption = LANGUAGE_OPTIONS.find(option => option.locale === locale)
    if (!languageOption) {
      return result
    }

    result.push({
      ...languageOption,
      nativeName: typeof nativeName === 'string' && nativeName.trim() ? nativeName : languageOption.nativeName,
    })
    return result
  }, [])

  if (languageOptions.length === 0) {
    return fallbackLanguageOptions
  }

  return languageOptions
}
